// Google Analytics 4 Service with Consent Management for Google Tag Manager
declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
    dataLayer: unknown[];
    adsbygoogle: unknown[];
  }
}

// Initialize Google Analytics with consent denied by default
export const initGA = (measurementId: string) => {
  // Initialize gtag with consent denied by default
  window.dataLayer = window.dataLayer || [];
  window.gtag = function(...args: unknown[]) {
    window.dataLayer.push(args);
  };
  window.gtag('js', new Date());
  
  // Set default consent to denied - Google Tag Manager will handle consent
  window.gtag('consent', 'default', {
    'ad_storage': 'denied',
    'analytics_storage': 'denied',
    'functionality_storage': 'denied',
    'personalization_storage': 'denied',
    'security_storage': 'granted'
  });
  
  // Load Google Analytics script
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script1);
  
  // Configure GA with measurement ID
  window.gtag('config', measurementId, {
    page_title: document.title,
    page_location: window.location.href,
  });
};

// Track page views (Google Tag Manager will handle consent)
export const trackPageView = (pageTitle: string, pagePath: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', 'G-XXXXXXXXXX', {
      page_title: pageTitle,
      page_location: `https://privatetools.tech${pagePath}`,
    });
  }
};

// Track search queries (Google Tag Manager will handle consent)
export const trackSearch = (query: string, resultsCount: number) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'search', {
      search_term: query,
      results_count: resultsCount,
      event_category: 'Search',
    });
  }
};

// Track category views (Google Tag Manager will handle consent)
export const trackCategoryView = (categoryName: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'category_view', {
      category_name: categoryName,
      event_category: 'Navigation',
      event_label: categoryName,
    });
  }
};

// Track user engagement (Google Tag Manager will handle consent)
export const trackEngagement = (action: string, label?: string, value?: number) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'user_engagement', {
      action: action,
      event_label: label,
      value: value,
      event_category: 'Engagement',
    });
  }
}; 